import { Builder } from "@builder.io/react";

import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from "../BuilderComponentsName";
import {  altBackgroundColorOptions, backgroundGradientOptions, textColorOptionsLimited } from "../utils/builderColorOptions";
import { S7SubCategoriesSection } from "../components/interactive-sections/S7SubCategoriesSection";
import { getBackgroundColorInput, getBackgroundGradientInput, getPaddingInputs } from "../utils/builderSharedInputs";


 Builder.registerComponent(S7SubCategoriesSection, {
    name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S7SubCategories,
    inputs: [
        {
            name: "headline",
            type: "string",
            defaultValue: "Headline",
            required: true,
        },
        {
            name: "headlineColor",
            type: "string",
            defaultValue: "Blue",
            friendlyName: "Headline Color",
            enum: textColorOptionsLimited,
            required: false,
        },
        {
            name: 'images',
            friendlyName: 'Images',
            type: 'list',
            required: true,
            helperText: 'Add Images',
            onChange: (options) => {
                // Check if the list has more than 4 items
                if (options.get('images').length > 4) {
                  options.set('images', options.get('images').slice(0, 4))
                  alert('maximum items are 4, delete items to continue')
                }
                // check if the list has less than 4 items
                if (options.get('images').length < 4) {
                    alert('minimum items are 4, add items to continue')
                }
            },
            defaultValue: [{
                src: "https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F835c694549a84729b8839cb17fc87494",
                label: "Chin",
                link: "/areas/face/lip-and-chin",
            },
            {
                src: "https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Fbce830e504f547b3927c4f81ff117555",
                label: "Upper Lip",
                link: "/areas/face/lip-and-chin",
            },
            {
                src: "https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F5dba9956112a40c5ae7def6db136a46f",
                label: "Beard",
                link: "/inclusive-clientele/for-men",
            },
            {
                src: "https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F10c56d3345dd4db49af5f5c8fc007525",
                label: "Eyebrows",
                link: "/areas",
            },],
            
            subFields: [
                {
                    name: 'src',
                    friendlyName: 'Image',
                    type: 'file',
                    required: true,
                    helperText: 'Upload image file',
                },
                {
                    name: 'imageAltText',
                    type: 'string',
                    friendlyName: 'Image Alt Text',
                    required: true,
                    helperText: 'Alt text for the image',
                },
                {
                    name: 'label',
                    friendlyName: 'Image Label',
                    type: 'string',
                    required: true,
                    helperText: 'Enter the label',
                    regex: {
                        pattern: '^.{1,12}$',
                        message: "More than 12 characters are entered, preview this entry before publishing",
                    }
                },
                {
                    name: 'link',
                    friendlyName: 'Image Link',
                    type: 'string',
                    required: true,
                    helperText: 'Enter the link',
                },
            ],
        },     
        ...getBackgroundColorInput({
            defaultValue: 'Turquoise20',
            backgroundColorsList: altBackgroundColorOptions,
        }),
          ...getBackgroundGradientInput({
            backgroundGradientName: "backgroundGradient",
            backgroundGradientList: backgroundGradientOptions
        }),
        ...getPaddingInputs()
       
    ],
    friendlyName: "S7 SubCategories",
 });

